module.exports = __webpack_public_path__ + "static/media/S (178).69e3e67a.jpg";